// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__16oW5","subheader":"ReorderModal_subheader__1tbi_","listWrap":"ReorderModal_listWrap__2rCVA"};